import type { HandState, PlayerId } from '@/engine/types';

/**
 * Pot odds: the fraction of the call-sized pot hero must win to break even.
 * potOdds = callCost / (pot + callCost).
 *
 * Equity > potOdds ⇒ +EV call.
 */
export function potOdds(state: HandState, playerId: PlayerId): number {
  const player = state.players.find((p) => p.id === playerId);
  if (!player) return 0;
  const toCall = Math.max(0, state.betting.currentBet - player.streetContribution);
  if (toCall === 0) return 0;
  const pot = state.players.reduce((s, p) => s + p.handContribution, 0);
  const cost = Math.min(toCall, player.stack);
  return cost / (pot + cost);
}

/** Total chips currently in the pot (sum of all players' handContribution). */
export function potSize(state: HandState): number {
  return state.players.reduce((s, p) => s + p.handContribution, 0);
}
